import React from "react";
import Card from "@material-ui/core/Card";
import { Button,makeStyles } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import VideocamIcon from '@material-ui/icons/Videocam';
import edit from "../../assets/images/edit.png";
export default function AlertDialog(props) {
  const [videoopen, setvideoOpen] = React.useState(false);
  const [errormes, setError] = React.useState("");
  const [video, setVideo] = React.useState("");
 const SUPPORTED_FORMATS_video =["video/*","video/mpeg","video/mp4"];
  React.useEffect(() => {
    if (props.text.type === "video") {
      setvideoOpen(true);
      if (props.text.value !== " ") {
        let file = props.text.value;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setVideo(reader.result);
        };
      }
      if (props.text.url !== "") {
        setVideo(props.text.url);
      }

    } else {
      setvideoOpen(false);
    }
  }, [props]);

  const handleFileselectorvideo = e => {
if(e.target.files[0].size<26214400  &&SUPPORTED_FORMATS_video.includes(e.target.files[0].type)){
setError();
     props.setTexts(e.target.files[0],props.keyid);
if(e.target.files[0]){
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setVideo(reader.result);
    };
  }
} else {
setError("File Size is greater than 25MB/Unsupported Format");
props.setTexts(' ',props.keyid);
setVideo();
  }
};
const useStyles = makeStyles(() => ({
video:{fontSize: "135px",color:"#fafafa"},
divclass:{ position: "relative",width: "265px",height: "130px",backgroundColor:"#bdbdbd",fontSize: "1.5em",textAlign: "center",lineHeight: "34px"},
editPen: {
		cursor: "pointer",
		width: 35,position: "absolute",top: 10,right:10
	}
}));
 const classes = useStyles();
  return (
    <div style={{marginTop:'20px'}}>
      <Card variant="outlined">
        <CardContent style={{height:"170px"}}>
          {videoopen ? (
            <>
              <Button
                size="small"
                onClick={() => props.handleDeletetext(props.text.id)}
                style={{ float: "right" }}
              >
                {" "}
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ fontSize: "14px", color: "red" }}
                />
              </Button>
              <div style={{display:"flex"}}>
              <div className={classes.divclass}>
              {props.text.value===" "&&props.text.url===""?<><VideocamIcon className={classes.video} /><img className={classes.editPen} src={edit} /></>
:<><video width="265" height="130" src={video} accept="video/webm,video/ogg,video/*" controls></video><img className={classes.editPen} src={edit} /></>}
                <TextField
                  style={{position: "absolute",top: 0,left: 0,opacity: 0,width: "265px",height: "45px"}}
                  autoFocus
                  name={props.textid}
                  type="file"
                  id="name"
                  inputProps={{accept:"video/webm,video/ogg,video/*,video/mpeg,video/mp4,video/x-ms-wmv,video/quicktime,video/avi"}}
                  onChange={handleFileselectorvideo}
                />
              </div>
              </div>
               <p style={{color:"#f44336",fontSize:" 0.75rem",paddingTop:"3px",paddingBottom:"5px"}}>{errormes}</p>

            </>
          ) : (
            ""
          )}
        </CardContent>
      </Card>
    </div>
  );
}
